module.exports = __webpack_public_path__ + "5fdd4470ab4568ea1d0e59dea7fd2050.pdf";